<template>
  <div>
    <BaseButton primary small @click="addProduct"> Add Product </BaseButton>
  </div>
</template>

<script>
import { accProductProductsClient } from '@/api/clients';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  props: {
    accProductId: {
      type: String,
      required: true,
    },
  },
  computed: {
    accProduct() {
      return this.$store.state.entities.accProducts.byId[this.accProductId] || null;
    },
  },
  methods: {
    addProduct() {
      this.$modal.show({
        component: () => import('Components/AccProductProducts/ProductAddModal.vue'),
        props: {
          action: this.storeProduct,
          accProduct: this.accProduct,
        },
        on: {},
        hideEvent: 'hide',
      });
    },
    async storeProduct(data) {
      try {
        await accProductProductsClient.store(this.accProductId, mapKeysToSnakeCase(data));

        this.$emit('product-added');

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
